@app.directive 'signupForm', (ModalService, AnalyticsService, $state, authenticationService, csAdwords, csFacebookConversion, formHelper, LocationService, ssoService, $location)->
  restrict: 'E'
  scope: {}
  controller: ($scope) ->
    @params = ModalService.params()

    LocationService.loadData()

    @showErrorFor = (fieldName, validationParam) =>
      formHelper.showErrorFor(@form, fieldName, validationParam)

    @close = ->
      ModalService.reject()

    @track = (extraProperties) =>
      csAdwords.track(998032928,'77TfCIjjrAgQoIzz2wM')
      csFacebookConversion.track(6014798030226,0.00)

      AnalyticsService.reidentify(true)

      if @sso
        properties = extraProperties
      else
        properties = angular.extend(ModalService.modal.params, extraProperties)
      AnalyticsService.track 'Signed Up JS', properties

      # Google Analytics
      AnalyticsService.track 'Complete', { category: 'Sign Up' }

    @submit = =>
      registrationSuccess = =>

        @track(method: 'standard')

        @showSuccess = true
        @showSpinner = false

        if @sso
          @state = $location.search().state
          ssoService.signAndRedirect(@state).then ((response) ->

          ), (error) =>
            @errorMessage = error
        else
          ModalService.ftueIfFromNav()

      registrationError = (response) =>
        @errorMessage = 'This email is already registered. Want to login or recover your password?'
        @showSpinner = false

      if @form.$valid
        @showSpinner = true

        authenticationService
          .registerWithEmail @form.name.$modelValue, @form.email.$modelValue, @form.password.$modelValue, (@form.optout?.$modelValue||false)
          .then registrationSuccess, registrationError

    @login = ->
      # Transfer params
      ModalService.open('login', ModalService.modal.params)

    @terms = ->
      ModalService.open('terms')

    @isInUS = ->
      LocationService.isInUS()

    this

  controllerAs: 'signup'
  bindToController: {
    sso: '='
    ftue: '='
  }
  templateUrl: "/assets/templates/directives/ssoForm/signupForm/signupForm.html"
